export default __webpack_public_path__ + "static/media/d-10.2ecb519a.png";